import React, { useMemo, useState } from "react";
import { connect } from "react-redux";
import { Button, Badge } from '@mui/material';
import "moment-timezone";
import AssignmentForm from "features/forms/AssignmentForm";
import BingoModal from "modules/bingoModule";
import COLOR from "utils/constants/color";
import OnegameModals from "components/OneGame/OneGameModal";
import OnestudyModals from "components/OneStudy/OneStudyModal";
import WorkSheetModal from "modules/workSheet";
import styled from "styled-components";
import { filter, find, get } from "lodash";
import { getBookData, getPageData } from "utils/lib/ebookHelper";
import { useVideos } from "store/resources/selectors";
import SoyHistoriasIconUpdated from "../utils/assets/images/SoyHistoriasIconUpdated.svg";
import GrammerIconDrill from "../utils/assets/images/GrammerIconDrill.svg";
import PresentationIcon from "../utils/assets/images/PresentationIcon.svg";
import AiActivityIcon from "../utils/assets/images/AiActivityIcon.svg";
import GenerateTestIcon from "../utils/assets/images/GenerateTestIcon.svg";
import SentryWrap from 'components/Sentry';

//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

import {
  Add,
  AssignmentOutlined
} from '@mui/icons-material';
import AssignmentsComponent from 'modules/assignments';
import GraphicOrganizerAssignments from 'components/GraphicOrganizerAssignment';
import GraphicAssignmentPreview from 'components/GraphicOrganizerAssignmentPreview';
import TeachersWorkSheet from 'modules/workSheet/TeachersWorkSheet';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import usePopUpAtOnce from 'components/hooks/usePopUpAtOnce';
import { useLearningModuleCount } from 'store/bingo/selectors';
import { isErrorContent } from "utils/methods/storyContentValidation";
import { useUserRole } from "store/users/selectors";
import AssignmentBuilderTool from 'components/AssignmentBuilder/AssignmentBuilderTool';

const TestGenerator = styled.button`
    width: 100%;
    max-width: 100%;
    height: auto;
    min-height: 35.16px;
    max-height: 35.16px;
    border-radius: 18px;
    background: #002d75;
    cursor: pointer;
    color: white;
    flex: 1 1 0%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 2px;
`;

const Section = styled.div`
  padding: 0px 0px 24px;

  margin-bottom: 16px;
  overflow-y: auto;
  // -ms-overflow-style: none; /* IE and Edge */
  // scrollbar-width: none; /* Firefox */

  &:first-child {
    border-bottom: none;
    margin-bottom: 0px;
    padding: 0px;
  }

  &:last-child {
    border-bottom: none;
    padding-bottom: 0px;
    // height: 300px;
  }

  // ::-webkit-scrollbar {
  //   display: none;
  // }
`;

const SectionHeader = styled.span`
  align-items: center;
  color: ${COLOR.black200};
  display: flex;
  flex-direction: row;
  font-size: 10px;
  font-weight: 600;
  justify-content: space-between;
  margin-bottom: 8px;
  text-transform: uppercase;
  width: 100%;
`;


const Wrapper = styled.div`
  height: 100%;
  width: 100%;
  overflow: hidden;
  position: relative;
  padding-top:10px;
`;



const DescriptionWrapper = styled.div`
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.5;
  color: #0b0b0c;
  background-color: rgb(234,228,237);
  width: 100%;
  height: 100%;
  min-height: 310px;
  padding: 10px;
  flex: 1;
`



const PodcastTooling = ({
  isDrawerOpen,
  currentClass,
  currentUser,
  id,
  quiz,
  activity,
  notes,
  section,
  tipsBook,
  quizzes,
  activities,
  classQuizzes,
  interactions,
  classActivities,
  setSubmitRef,
  timmer,
  onFinish,
  booksAllList,
  videoInfo,
  track,
  engTrack,
  title,
  listenActions,
  timeInt,
  handleOpenStoryWithAi = () => {},
  hasStoryWithAi,
  onGenerateClick = () => {},
  handlerOpenPresentation = () => {},
  has_all_page
}) => {
  const videos = useVideos();
  const [studyModals, setStudyModals] = useState(false);
  const [aiModals, setAiModals] = useState(false);
  const { is_student, is_teacher, is_admin } = useUserRole();
  const {checkPopUpAtOnce, updatePopUpAtOnce} = usePopUpAtOnce();
  const isStudent = is_student;
  // ---new logic-------------//
  const bookData = getBookData(activities, quizzes, null, notes, null, interactions, classActivities, classQuizzes, id,currentClass.id,false,currentUser.id)
  const pageData = getPageData(bookData, id, quiz, activity)
  const learningModuleCount = useLearningModuleCount();

  const pageLearningModuleCount = useMemo(() => {
    return learningModuleCount?.result?.find(item => String(item?.page) === String(id)) || {};
  }, [learningModuleCount, id]);

  const isStudentTakingAssignment = useMemo(() => {
    if (!isStudent) return false;
    return (
      (typeof quiz === "string" && quiz.length > 2 && quiz !== "null") ||
      (typeof activity === "string" && activity.length > 2 && activity !== "null")
    );
  }, [isStudent, quiz, activity]);

  const activeActivity = pageData.activeActivity;

 

  const activeQuiz = pageData.activeQuiz;
  // ---new logic end-------------//
  const descriptionVideo = useMemo(() => filter(tipsBook, (x) => x.texType === "description"), [tipsBook]);
  const [customAssignmentDrawer, setCustomAssignmentDrawer] = useState(false);
  const [assignmentBuilderOpen, setAssignmentBuilderOpen] = useState(false);
  const [assignmentBuilderSeed, setAssignmentBuilderSeed] = useState(null);
  const [openGraphicAssignmentPrivew, setOpenGraphicAssignmentPrivew] = useState(false);
  const [graphicAssignment, setGraphicAssignment] = useState({});
  const showAlert = useAlert();
  const [isOpen, setIsOpen] = useState(false);


  const infoDescription = useMemo(() => {
    if (descriptionVideo.length > 0) {
      return descriptionVideo[0];
    } else {
      return {
        textTip: "",
      };
    }
  }, [descriptionVideo]);

  const handleForDistrictAdmin = () => {
    if (currentUser.role === 'admin') {
      showAlert("Please login as teacher!", "error");
      return true;
    }
    return false;
  };

  const hasActiveAssignmentDrawer = () => {
    const hasActiveQz = activeActivity || activeQuiz
    return (typeof quiz == "string" && quiz.length > 2 && quiz !== 'null') || (typeof activity == "string" && activity.length > 2 && activity !== 'null' && hasActiveQz)
  }

  const isTeacher = is_teacher;
  const isDistrictAdmin = is_admin;
  return (
    <SentryWrap>
      <div style={{marginTop:'10px'}}>
      <TeachersWorkSheet setIsOpen={setIsOpen} isOpen={isOpen} book_id={id} page_id={id} numberMasked={""} />
      {customAssignmentDrawer ? (
        <AssignmentForm
          open={customAssignmentDrawer}
          onClose={() => {
            setCustomAssignmentDrawer(false);
            setAssignmentBuilderSeed(null);
          }}
          bookId={id}
          pageId={id}
          from="podcast"
          pageSrc={get(videoInfo, 'poster') || get(videoInfo, 'src') || ''}
          formResource="resource"
          ai_questions={assignmentBuilderSeed?.ai_questions}
          assignmentTitle={assignmentBuilderSeed?.assignmentTitle}
        />
      ) : null}
     {assignmentBuilderOpen && <AssignmentBuilderTool
        open={assignmentBuilderOpen}
        onClose={() => setAssignmentBuilderOpen(false)}
        data={{}}
        page={id}
        chapter={id}
        from="podcast"
        pageTitle={get(videoInfo,"displayName") || ""}
        pageSrc={get(videoInfo, 'poster') || get(videoInfo, 'src') || ''}
        generatedTest
      />}
      {/* {((isTeacher||isDistrictAdmin) || listenActions?.caption) && (
         <TrackDownloader vttText={track}  id={id} title={title} engTrack={engTrack} />
      )} */}
      
    
 
      {section == 3 && (
        <>
          <Wrapper>
            <div>
              <Section>

                <DescriptionWrapper>
                  {infoDescription.textTip?infoDescription.textTip:get(videoInfo,"description")}
                </DescriptionWrapper>

              </Section>
            </div>
          </Wrapper>
        </>
      )}
      {section == 2 && (
        <div style={{marginTop: '10px'}}>
          <Wrapper>
            {/* Loteria */}
            
            {!isStudentTakingAssignment && (
            <>
            <div className={`gameStudyBtn gameStudyBtnRsrc  ${isDrawerOpen ? 'podcastDrawerOpen' : ''}`} style={{marginBottom: '0px'}}>
              {!isStudent && <BingoModal page={id} chapter={id} newMaskId={videoInfo?.displayName || ""} pageLearningModuleCount={pageLearningModuleCount} />}
              {(isTeacher || isDistrictAdmin) && (
                <div style={{position: "relative"}}>
                  <OnegameModals
                    aiModal={aiModals}
                    newMaskId={videoInfo?.displayName || ""} 
                    setAiModal={setAiModals}
                    booksAllList={booksAllList}
                    chapter={id}
                    page={id}
                    currentClass={currentClass}
                    currentUser={currentUser}
                    resource={true}
                    // page_1game_ai_content={page_1game_ai_content}
                    />
                </div>   
                
              )}

              <div style={{position: "relative"}}>
                <OnestudyModals
                aiModal={studyModals}
                newMaskId={videoInfo?.displayName || ""} 
                setAiModal={setStudyModals}
                booksAllList={booksAllList}
                chapter={id}
                page={id}
                currentClass={currentClass}
                currentUser={currentUser}
                resource={true}
                // page_1game_ai_content={page_1game_ai_content}
              />
                </div>
              {(isTeacher || isDistrictAdmin) && (
                <div className='vocOrGame' style={{ display: 'flex', alignItems: 'center', justifyContent: get(currentUser, "role") === "student" ? '' : 'center' }} >
                <button onClick={() => {
                  if(checkPopUpAtOnce()) return;
                  handleOpenStoryWithAi();
                }} className='addOneImg 1111'>
                <Badge 
                  overlap="rectangular" 
                  badgeContent={
                    pageLearningModuleCount && 
                    pageLearningModuleCount.soy_historias_status && 
                    Array.isArray(hasStoryWithAi) && 
                    hasStoryWithAi.filter(item => !isErrorContent(item?.story_content || '')).length > 0
                      ? "✓" 
                      : undefined
                  }   
                  color="success" 
                  variant="standard"
                  sx={{width: '100%'}}
                  // style={{position: "absolute", top: 0, right: 5, borderRadius: "50%", width: "20px", height: "20px", display: "flex", justifyContent: "center", alignItems: "center"}}
                >
                 
                  <img src={SoyHistoriasIconUpdated} alt='SoyHistorias' title='SoyHistorias' />
                </Badge>
                </button> 
                </div>
              )}
              {isStudent && Array.isArray(hasStoryWithAi) && hasStoryWithAi.filter(item => !isErrorContent(item?.story_content || '')).length > 0 && (
                <div className='vocOrGame' style={{ display: 'flex', alignItems: 'center', justifyContent: get(currentUser, "role") === "student" ? '' : 'center' }} >
                
                
                  <button onClick={handleOpenStoryWithAi} className='addOneImg 1212'>
                  <Badge 
                  overlap="rectangular" 
                  badgeContent={
                    pageLearningModuleCount && 
                    pageLearningModuleCount.soy_historias_status && 
                    Array.isArray(hasStoryWithAi) && 
                    hasStoryWithAi.filter(item => !isErrorContent(item?.story_content || '')).length > 0
                      ? "✓" 
                      : undefined
                  } 
                  color="success" 
                  variant="standard"
                  sx={{width: '100%'}}
                >
                    <img src={SoyHistoriasIconUpdated} alt='SoyHistorias' title='SoyHistorias' />
                  </Badge>
                  </button>
                </div>
              )}
              
              {!isStudent && <GraphicAssignmentPreview open={openGraphicAssignmentPrivew} setOpen={setOpenGraphicAssignmentPrivew} assignment={graphicAssignment} page_id={id}  bookId={id} />}
              {!isStudent &&
                <div className='vocOrGame' style={{ display: 'flex', alignItems: 'center', justifyContent: get(currentUser, "role") === "student" ? '' : 'center' }} >
                
                  <button onClick={() => {
                    if(checkPopUpAtOnce()){
                      return;
                    }
                    updatePopUpAtOnce(true);
                    if (handleForDistrictAdmin()) return;
                    setIsOpen(true)
                    }} className='addOneImg'
                  >
                    <Badge 
                  overlap="rectangular" 
                  badgeContent={pageLearningModuleCount?.worksheet_status ? "✓" : undefined}  
                  color="success" 
                  variant="standard"
                  sx={{width: '100%'}}
                >
                    <img src={GrammerIconDrill} alt="Grammar Drills" title="Grammar Drills" />
                  </Badge>
                  </button>
                </div>
              }
              {!isStudent && Boolean(has_all_page && has_all_page.length > 0) && <button onClick={() => handlerOpenPresentation()} className='addOneImg'>
                <Badge 
                  overlap="rectangular" 
                  badgeContent={"✓"} 
                  color="success" 
                  variant="standard"
                  sx={{width: '100%'}}
                >
                  <img src={PresentationIcon} alt="Presentation" title="Presentation" />
                </Badge>
                </button>}
              {!isStudent && <button onClick= {() => {if (handleForDistrictAdmin()) return; onGenerateClick()}} className='addOneImg'><img src={AiActivityIcon} alt="Ai Activity" title="Ai Activity" /></button>}
              {!isStudent  && <GraphicOrganizerAssignments page={id} chapter={id} isResource={true} />}
              
            </div>
            <div className={`gameStudyBtn gameStudyBtnRsrc bottomFadeShadow ${isDrawerOpen ? 'podcastDrawerOpen' : ''}`}>
              {!isStudent && (
                <TestGenerator
                  type="button"
                  onClick={() => {
                    if (handleForDistrictAdmin()) return;
                    setAssignmentBuilderOpen(true);
                  }}

                  className="addOneImg"
                  style={{ flex: 1, width: '100%' }}
                  title="Assignment Builder"
                >
                  <img src={GenerateTestIcon} alt="Generate Test" title="Generate Test" />
                </TestGenerator>
              )}
            </div>
            </>
            )}
            
            {/* diable for testing */}
            {/* {!hasActiveAssignmentDrawer() && isTeacher ? (
              <Section style={{
                height: "auto", overflowY: 'auto', backgroundColor: "transparent",
                position: "relative",
                marginBottom: 0, borderBottomWidth: 0, padding: 5
              }}>
                <SectionHeader>
                  <Button
                    color="primary"
                    onClick={() => setCustomAssignmentDrawer(true)}
                    style={{ fontSize: '12px' }}
                  >
                    <Add style={{ marginRight: '4px', fontSize: '13px' }} />
                    Add Assignment
                  </Button>
                </SectionHeader>
              </Section>
            ) : null} */}
              <AssignmentsComponent 
              sectionStyle={{style:{maxHeight: "60%"},className: "addSection container-activity-video removeScrol"}} 
              bookId={id} pageId={id}  student_render_assignments={true} from='podcast' id={id}
              timmer={timmer} onFinish={onFinish} setSubmitRef={setSubmitRef} timeInt={timeInt} 
              isStudentTakingAssignment={isStudentTakingAssignment}
              pageLearningModuleCount={pageLearningModuleCount}
              />
          </Wrapper>
        </div>
      )}
      </div>
    </SentryWrap>
  );
};


//  ----------------------------------------------------------------------------
//  Redux
//  ----------------------------------------------------------------------------
const mapStateToProps = (state) => ({
  currentClass: state.currentClass,
  currentUser: state.currentUser,
  notes: state.notes,
  classActivities: state.classActivities,
  classQuizzes: state.classQuizzes,
  interactions: state.interactions,
  quizzes: state.quizzes,
  activities: state.activities,
  booksAllList: state.booksAllList,
});

export default connect(mapStateToProps, null)(PodcastTooling);